import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "./Common/Footer";

import LandingPage from "./LandingPage";
import AboutPage from "./Pages/AboutPage"; 
import TemplateBuilder from "./Pages/TemplateBuilder"; 
import Campaign from "./Pages/Campaign";
import Erp from "./Pages/Erp";
import Mailing from "./Pages/Mailing";
import Pricing from "./Pages/Pricing";
import Crm from "./Pages/Crm";
import ComingSoon from "./Pages/ComingSoon";
import ReferralPage from "./Pages/ReferralPage";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsOfServices from "./Pages/TermsOfServices";
import UserDataDeletion from "./Pages/UserDataDeletion";
import Contactus from "./Pages/Contactus";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/templatebuilder" element={<TemplateBuilder />} />{" "}
        {/* New route */}
        <Route path="/campaign" element={<Campaign />} />
        <Route path="/erp" element={<Erp />} />
        <Route path="/mailing" element={<Mailing />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/crm" element={<Crm />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/referral" element={<ReferralPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
         <Route path="/terms-of-services" element={<TermsOfServices />} />
            <Route path="/user-data-deletion" element={<UserDataDeletion />} />
             <Route path="/contact" element={<Contactus />} />
      </Routes>
    </Router>
  );
}

export default App;
